<template>
	<div class="lander">
		<div class="inner">
			<div class="logo">
				<img src="../assets/logo@2x.png">
			</div>
			<transition name="fade-text">
				<h1 :key="activeCopy">{{activeCopy}}</h1>
			</transition>
			<a class="lets-talk" href="mailto:jeff@sargentlabs.com">LETS TALK</a>
		</div>
	</div>
</template>

<script>
import {TimelineMax} from 'gsap';
import _ from 'lodash';

var tl = new TimelineMax({repeat:-1});
var fadeConfig = {
	fadeSpeed: 2,
	displayLength: 4
};

export default {
	name: 'Lander',
	data () {
		return {
			activeIndex: 0,
			timer: null,
			items: [
				{id: 0, color: 'primary', 'copy': 'A Daily Drive To Innovate'},
				{id: 1, color: 'secondary', 'copy': 'Clean, Simple & Bold'},
				{id: 2, color: 'third', 'copy': 'Lightning In A Bottle'},
				{id: 3, color: 'fourth', 'copy': 'We Have No Off-Switch'}
			]
		}
	},
	methods: {
		toggle(){
			let oldIndex = this.activeIndex;
			let item = _.sample(this.items);
			this.activeIndex = item.id;
			var body = document.body;
			body.classList.remove(this.items[oldIndex].color);
			body.classList.add(this.items[this.activeIndex].color);

		},
		startTimer: function(){
			this.timer = setInterval(this.toggle, 3*1000);
		},
		stopTimer(){
			clearInterval(this.timer);
		},
	},
	computed: {
		activeCopy(){
			if(!_.isNil(this.items[this.activeIndex])){
				return this.items[this.activeIndex].copy;
			}else{
				return "";
			}
		}
	},
	destroyed(){
		this.stopTimer();
	},
	mounted(){
		this.startTimer();
	},
}
</script>
<style lang="scss">
body{
	background-color: #ED4C4C;
	font-family: 'Questrial', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #FFFFFF;
	transition: background-color 1000ms ease;
	h1{
		color: #FFFFFF;
		font-size: 41px;
		line-height: 145px;
		position: absolute;
		width: 100%;
		text-align: center;
		@media screen and (max-width: 767px){
			font-size: 40px;
			line-height: 50px;
			margin-top: 50px;
		}
	}
	a{
		color: #FFFFFF;
		font-family: 'Nanum Gothic', 'Questrial', Helvetica, Arial, sans-serif;
		font-weight: 600;
		font-size: 18px;
		text-decoration: none;
		letter-spacing: 7px;
	}
	.fade-text-enter-active, .fade-text-leave-active{
		transition: opacity 0.7s ease;
	}
	.fade-text-enter{
		opacity: 0;
	}
	.fade-text-enter-to, .fade-text-enter-active{
		opacity: 1;
	}
	.fade-text-leave-to{
		opacity: 0;
	}
	.lander{
		border: 4px solid #FFFFFF;
		width: 100%;
		max-width: 646px;
		height: 252px;
		margin: 0 auto;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		@media screen and (max-width: 767px){
			width: calc(100% - 50px);
			left: 20px;
			top: 40px;
			transform: none;
		}
		.inner{
			// position: relative;
			.logo{
				opacity: 0;
				text-align: center;
				width: 276px;
				margin: 0 auto;
				background-color: #ED4C4C;
				transition: all 1000ms ease;
				// position: absolute;
				margin-top: -30px;
				img{
					max-width: 196px;
				}
				@media screen and (max-width: 767px){
					width: auto;
					max-width: 220px;
				}
			}
			a{
				opacity: 0;
				display: inline-block;
				width: 208px;
				margin: 211px auto 0px;
				background-color: #ED4C4C;
				transition: all 1000ms ease;
			}
		}
	}
	&.primary{
		background-color: #ED4C4C;
		.lander{
			.inner{
				.logo, a{
					opacity: 1;
					background-color: #ED4C4C;
				}
			}
		}
	}
	&.secondary{
		background-color: #4B8FE6;
		.lander{
			.inner{
				.logo, a{
					opacity: 1;
					background-color: #4B8FE6;
				}
			}
		}
	}
	&.third{
		background-color: #DA60EB;
		.lander{
			.inner{
				.logo, a{
					opacity: 1;
					background-color: #DA60EB;
				}
			}
		}
	}
	&.fourth{
		background-color: #3CE4A8;
		.lander{
			.inner{
				.logo, a{
					opacity: 1;
					background-color: #3CE4A8;
				}
			}
		}
	}

}

</style>



// WEBPACK FOOTER //
// src/components/Lander.vue